export enum SubmissionNavbarBrandMode {
  PaperlessLogo = 'PaperlessLogo',
  SpecialLogo = 'SpecialLogo',
  Text = 'Text'
}
